/* JC · Proof strip. Counts each number up once, the moment the strip starts to scroll into view, then lands on the exact
   server-rendered text ("7,200+", "4.8", "60+"). Skipped when the strip is already on screen at load (no flashing
   zeros) and under prefers-reduced-motion. The number format (prefix, commas, decimals, suffix) is read from the
   text itself, so it always matches the fact in Theme settings. */
(function () {
  'use strict';
  var RM = window.matchMedia('(prefers-reduced-motion: reduce)');

  // German pages write "7.200+" and "4,8": the group and decimal marks swap.
  var DE = /^de\b/i.test(document.documentElement.lang || '');
  var G = DE ? '.' : ',', D = DE ? ',' : '.';
  var RX = DE ? /^(\D*?)(\d{1,3}(?:\.\d{3})+|\d+)(?:,(\d+))?(\D*)$/ : /^(\D*?)(\d{1,3}(?:,\d{3})+|\d+)(?:\.(\d+))?(\D*)$/;

  function parse(text) {
    var m = text.match(RX);
    if (!m) return null;
    return { pre: m[1], to: parseFloat(m[2].split(G).join('') + (m[3] ? '.' + m[3] : '')), dec: m[3] ? m[3].length : 0, group: m[2].indexOf(G) > -1, suf: m[4] };
  }
  function format(p, v) {
    var s = p.dec ? v.toFixed(p.dec).replace('.', D) : String(Math.round(v));
    if (p.group) s = s.replace(/\B(?=(\d{3})+(?!\d))/g, G);
    return p.pre + s + p.suf;
  }
  function track(name) {
    window.dataLayer = window.dataLayer || [];
    window.jcPush({ event: 'jc_' + name });
  }

  function init(root) {
    if (root.hasAttribute('data-jc-ps-init')) return;
    root.setAttribute('data-jc-ps-init', '');
    if (!('IntersectionObserver' in window)) return;

    var items = Array.prototype.slice.call(root.querySelectorAll('[data-jc-ps-n]'))
      .filter(function (el) { return !el.children.length; })   // skip editor badges
      .map(function (el) { var t = el.textContent.trim(); return { el: el, text: t, p: parse(t) }; })
      .filter(function (x) { return x.p; });

    var first = true, armed = false, done = false;
    var io = new IntersectionObserver(function (entries) {
      var e = entries[entries.length - 1];
      if (first) {
        first = false;
        // On screen at load, or nothing to count, or reduced motion: leave the real numbers alone.
        if (!e.isIntersecting && !RM.matches && items.length) {
          armed = true;
          items.forEach(function (x) { x.el.textContent = format(x.p, 0); });
        }
      }
      // Count as soon as any of it shows: a strip peeking in at the bottom of the screen never reads "0+".
      if (done || !e.isIntersecting) return;
      done = true;
      io.disconnect();
      track('proof_strip_view');
      if (!armed) return;
      var t0 = performance.now();
      function step(now) {
        var k = Math.min(1, (now - t0) / 1100);
        var ease = 1 - Math.pow(1 - k, 3);
        items.forEach(function (x) { x.el.textContent = k < 1 ? format(x.p, x.p.to * ease) : x.text; });
        if (k < 1) requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
    }, { threshold: 0 });
    io.observe(root);
  }

  function boot() { Array.prototype.forEach.call(document.querySelectorAll('[data-jc-ps]'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
